module.exports = __webpack_public_path__ + "img/9.7877b4bf.png";